import manifest from '@/manifest.json';

const setPWAurl: () => any = () => {
  const manifestElement = document.getElementById('manifest');
  const manifestString = JSON.stringify({
    ...manifest,
    start_url: `${window.location.href}`,
  });
  manifestElement?.setAttribute(
    'href',
    `data:application/json;charset=utf-8,${encodeURIComponent(manifestString)}`
  );
};

const ManifestSettings = { setPWAurl };

export default ManifestSettings;
